'use client';

import { c as _c } from "react/compiler-runtime";
import { ContentContainer } from '@module/mdrt-org/shared/components/content-container/content-container';
import { Pagination } from '@module/mdrt-org/shared/components/pagination/pagination';
import { Table } from '@module/mdrt-org/shared/components/table/table';
import { Button } from '@shared/ui-components/button/button';
import { ChevronUp, DownloadIcon } from '@shared/ui-components/svgs';
import { useFormatTranslationString } from '@shared/utils/helpers/format-translation-string';
import { PAGE_SIZE } from '../../utils/get-company-listings/get-company-listing';
import { type TableData } from '../../utils/get-table-data';
import styles from './company-listing-table.module.scss';
type CompanyListingTableProps = {
  companyNameWithId: string;
  currentPage: number;
  downloadButtonLabel?: string;
  isDownloadDisabled?: boolean;
  isDownloading?: boolean;
  onDownload?: () => void;
  onPageChange: (page: number) => void;
  onSort: (field: string) => void;
  recordsFoundText: string;
  sortAscending: boolean;
  sortField: string | undefined;
  tableData: TableData;
};
export const CompanyListingTable = t0 => {
  const $ = _c(48);
  const {
    companyNameWithId,
    currentPage,
    downloadButtonLabel,
    isDownloadDisabled,
    isDownloading,
    onDownload,
    onPageChange,
    onSort,
    recordsFoundText,
    sortAscending,
    sortField,
    tableData
  } = t0;
  const formatTranslationString = useFormatTranslationString();
  let t1;
  if ($[0] !== companyNameWithId) {
    t1 = <h2 className={styles["table-section__title"]}>{companyNameWithId}</h2>;
    $[0] = companyNameWithId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== formatTranslationString || $[3] !== recordsFoundText || $[4] !== tableData.totalCount) {
    t2 = formatTranslationString(recordsFoundText, {
      totalResults: tableData.totalCount
    });
    $[2] = formatTranslationString;
    $[3] = recordsFoundText;
    $[4] = tableData.totalCount;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <span className={styles["table-section__count"]}>{t2}</span>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className={styles["table-section__title-wrapper"]}>{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== downloadButtonLabel || $[12] !== isDownloadDisabled || $[13] !== isDownloading || $[14] !== onDownload) {
    t5 = downloadButtonLabel && <Button disabled={isDownloadDisabled} isSmall={true} isSubmitting={isDownloading} onClick={onDownload} prefix={<DownloadIcon />}>{downloadButtonLabel}</Button>;
    $[11] = downloadButtonLabel;
    $[12] = isDownloadDisabled;
    $[13] = isDownloading;
    $[14] = onDownload;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <ContentContainer><header className={styles["table-section__header"]}>{t4}{t5}</header></ContentContainer>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== onSort || $[20] !== sortAscending || $[21] !== sortField || $[22] !== tableData.columns) {
    let t8;
    if ($[24] !== onSort || $[25] !== sortAscending || $[26] !== sortField) {
      t8 = t9 => {
        const {
          key,
          label
        } = t9;
        const isSorted = sortField === key;
        return <th aria-sort={isSorted ? sortAscending ? "ascending" : "descending" : "none"} key={key} onClick={() => onSort(key)} scope="col"><span className={styles["table-section__th-content"]}>{label}{isSorted && <ChevronUp className={sortAscending ? styles["table-section__sort-icon"] : styles["table-section__sort-icon--descending"]} />}</span></th>;
      };
      $[24] = onSort;
      $[25] = sortAscending;
      $[26] = sortField;
      $[27] = t8;
    } else {
      t8 = $[27];
    }
    t7 = tableData.columns.map(t8);
    $[19] = onSort;
    $[20] = sortAscending;
    $[21] = sortField;
    $[22] = tableData.columns;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[28] !== t7) {
    t8 = <thead><tr>{t7}</tr></thead>;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== tableData.columns || $[31] !== tableData.rows) {
    let t10;
    if ($[33] !== tableData.columns) {
      t10 = (row, index) => <tr key={index}>{tableData.columns.map(t11 => {
          const {
            formatValue,
            key: key_0
          } = t11;
          return <td key={key_0}>{formatValue ? formatValue(row[key_0]) : row[key_0]}</td>;
        })}</tr>;
      $[33] = tableData.columns;
      $[34] = t10;
    } else {
      t10 = $[34];
    }
    t9 = tableData.rows.map(t10);
    $[30] = tableData.columns;
    $[31] = tableData.rows;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[35] !== t9) {
    t10 = <tbody>{t9}</tbody>;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== t8) {
    t11 = <div className={styles["table-section__scroll"]}><Table className={styles["table-section__table"]}>{t8}{t10}</Table></div>;
    $[37] = t10;
    $[38] = t8;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== currentPage || $[41] !== onPageChange || $[42] !== tableData.totalCount) {
    t12 = <div className={styles["table-section__pagination"]}><Pagination currentPage={currentPage} maxItemsPerPage={PAGE_SIZE} onPageChange={onPageChange} totalItemsCount={tableData.totalCount} /></div>;
    $[40] = currentPage;
    $[41] = onPageChange;
    $[42] = tableData.totalCount;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] !== t11 || $[45] !== t12 || $[46] !== t6) {
    t13 = <section className={styles["table-section"]}>{t6}{t11}{t12}</section>;
    $[44] = t11;
    $[45] = t12;
    $[46] = t6;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  return t13;
};